diy.angular.registerFactory('diyfmsectioncompany', [
    '$timeout', 
    'diyl10n', 
    'diyfmsectionmodel', 
    'diyfmsubsectionmodel', 
    'diyfmsourcekeyvisuals',
    'diyfmconstkeyvisual',
    'diyfmsourcepatterns',
    'diyfmconstpattern',
    'diyfmsourcecms',
    'diyfmconstcms',
    'diyinfo',
    'diyfmconfig',
function(
    $timeout, 
    diyl10n, 
    diyfmsectionmodel,
    diyfmsubsectionmodel,
    diyfmsourcekeyvisuals,
    diyfmconstkeyvisual,
    diyfmsourcepatterns,
    diyfmconstpattern,
    diyfmsourcecms,
    diyfmconstcms,
    diyinfo,
    diyfmconfig
) {

    // constructor
    var diyfmsectioncompany = function () {
        diyfmsectionmodel.call(this, 'companySection', diyl10n('filemanager.companySection.title')); //call parent constructor
    }; 
    
    // diyfmsectioncompany extends diyfmsectionmodel
    diyfmsectioncompany.prototype = Object.create(diyfmsectionmodel.prototype);
    
    // static methods
    diyfmsectioncompany.getOrder = function() {
        return 1;
    };
    
    // public methods
    angular.extend(diyfmsectioncompany.prototype, {
        initializeSubsections: function(sources) {
           	// call parent
            diyfmsectionmodel.prototype.initializeSubsections.apply(this, arguments);
        
            if (sources.indexOf(diyfmsourcecms) !== -1) {
                if (diyfmsourcecms.isAvailable() || diyfmsourcecms.shouldShowUpsell()) {
                    // all photos section //
                    this.addSubsection(new diyfmsubsectionmodel(
                        diyfmconstcms,
                        diyl10n('filemanager.companySection.photos'),
                        diyfmsourcecms,
                        'cmsPhotos'
                    ));
        
                    // recommendations section //
                    this.addSubsection(new diyfmsubsectionmodel(
                        diyfmconstcms,
                        diyl10n('filemanager.companySection.recommendedPhotos'),
                        diyfmsourcecms,
                        'recommendedCmsPhotos',
                        {topicId: diyinfo.getTopicId()} // default params
                    ));
                }
            }            
            
            if (sources.indexOf(diyfmsourcekeyvisuals) !== -1) {
                this.addSubsection(new diyfmsubsectionmodel(
                    diyfmconstkeyvisual, 
                    diyl10n('filemanager.companySection.keyvisuals'),
                    diyfmsourcekeyvisuals,
                    // TODO refactor to get rid of too many constants
                    'keyvisualsPhotos'
                ));
            }
            if (sources.indexOf(diyfmsourcepatterns) !== -1) {   
                this.addSubsection(new diyfmsubsectionmodel(
                    diyfmconstpattern,
                    diyl10n('filemanager.companySection.patterns'),
                    diyfmsourcepatterns,
                    // TODO refactor to get rid of too many constants
                    'patterns'
                ));
            }

        }
    });
    
    return diyfmsectioncompany;
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/sections/diyfmsectioncompany.js
 ** module id = 962
 ** module chunks = 0
 **/